import { useSpring } from "@react-spring/web";
import { useEffect } from "react";

import { convertSizeBasedOnResolution } from "@is/utils";

type Props = {
  count: number;
};

const ANIMATION_DURATION = 250;

const useManageBasketButton = ({ count }: Props) => {
  const [styles, api] = useSpring(() => ({
    width: 0,
    height: 0,
    config: {
      duration: ANIMATION_DURATION,
    },
  }));

  useEffect(() => {
    if (count) {
      api.start({
        width: convertSizeBasedOnResolution(44),
        height: convertSizeBasedOnResolution(44),
      });

      setTimeout(() => {
        api.start({
          width: convertSizeBasedOnResolution(32),
          height: convertSizeBasedOnResolution(32),
        });
      }, ANIMATION_DURATION);
    } else {
      api.start({
        width: 0,
        height: 0,
      });
    }
  }, [count, api]);

  return {
    styles,
  };
};

export default useManageBasketButton;
